<template>
    <button
        v-tippy="t('editorMergeCells')"
        :class="[buttonState(editor.can().mergeCells()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().mergeCells()"
        @click="editor.chain().focus().mergeCells().run()"
    >
        <MdiTableMergeCells class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableMergeCells from 'materialdesignicons-vue3/icons/MdiTableMergeCells.js';

    defineExpose({
        name: 'TableMergeCellsButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
